import React, { Fragment, useState, useEffect } from "react";
import { Col, Row, Form, Button } from "reactstrap";
import SikkaInput from "../common/SikkaInput";
import { useForm } from "react-hook-form";
import APICall from "../../services/apiCall";
import { toast } from "react-toastify";

const DeleteApplicationForm = (props) => {
  const {
    setOpenDeleteModal,
    applicationData,
    loginUserDetails,
    applicationList,
    setFetchAfterUpdate,
    setFirstStartupApplicationBoolean,
    setSelectedApiNames,
    setApiLimitNote,
  } = props;

  const { register, handleSubmit, errors } = useForm();
  const [isDeleteButtpnDisable,setIsDeleteButtpnDisable] =useState(false)
  const onSubmit = (values) => {
    setFetchAfterUpdate(false);
    let body = {
      app_id: applicationData.app_id,
      is_deleted_by_admin: loginUserDetails.is_partner === "0" ? "true" : "false", //[if deleted by sikka admin then true else false]
      deleted_by: loginUserDetails.user_name, //[loggedin user username/email],
      comment: values.comment || "", //optional if we get comment from user then only pass else blank
      user_dev_id:loginUserDetails.dev_id
    };
    setIsDeleteButtpnDisable(true)
    APICall.servertrip("DELETE", "application", loginUserDetails, undefined, body)
      .then((res) => {
        toast.success(`${applicationData.app_name} Application Deleted Successfuly`);
        setOpenDeleteModal(false);
        setFetchAfterUpdate(true);
        if (applicationList.length === 1) {
          setFirstStartupApplicationBoolean(false);
          setSelectedApiNames([]);
          setApiLimitNote("");
          setIsDeleteButtpnDisable(true)
        }
      })
      .catch((error) => {
        const resMessage =
          (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        toast.error(resMessage);
        setOpenDeleteModal(false);
        setFetchAfterUpdate(true);
        setIsDeleteButtpnDisable(true)
      });
  };

  return (
    <Fragment>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <Col>
            <SikkaInput
              label="Comment"
              placeholder="write your comment"
              id="comment"
              name="comment"
              innerRef={register({
                required: "Comment is required",
                pattern: {
                  value: /^[^\s]+(\s+[^\s]+)*$/,
                  message: "Invalid comment",
                },
              })}
              errors={errors}
            />
          </Col>
        </Row>

        <Row
          form
          className="modal-footer px-md-3 bg-light"
          style={{ marginLeft: "-16px", marginRight: "-16px", marginBottom: "-16px" }}
        >
          <Button size="sm" className="ml-auto" color="outline-danger" type="submit" disabled={isDeleteButtpnDisable}>
            Delete
          </Button>
          <Button
            color="outline-secondary"
            size="sm"
            onClick={() => {
              setOpenDeleteModal(false);
            }}
          >
            Cancel
          </Button>
        </Row>
      </Form>
    </Fragment>
  );
};

export default DeleteApplicationForm;
